import { UpsellPricingRadioCardsParcel } from 'parcels/imported/UpsellPricingRadioCardsParcel';
import React, { useCallback } from 'react';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';

export const PartnerUpsell: React.FC = () => {
    const { selectedPlan, handlePlanSelect, handleFrequencyChange } =
        useUpsellActionsContext();

    const onPlanChange = useCallback(
        (plan: string | undefined, isYearly: boolean) => {
            handlePlanSelect(plan ?? '');
            handleFrequencyChange(isYearly);
        },
        [handlePlanSelect, handleFrequencyChange],
    );

    return (
        <UpsellPricingRadioCardsParcel
            allowedFeatureUpsell="SamplePaidContentAccess"
            selectedPlan={selectedPlan}
            onPlanChange={onPlanChange}
        />
    );
};
